import React from 'react'
import { Cube } from '../geometries/Cube'

export const Wall = ({ position = [0, 0, 0], height, width, color }) => {
	return (
		<group position={position} receiveShadow>
			<Cube color={color} position={[0, 40, 0]} size={[width, 80, height]} />
		</group>
	)
}
